import Vue from 'vue';
import VueRouter from 'vue-router';

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: '游戏初始化',
		component: () => import('@/views/HomeView.vue'),
	},
	{
		path: '/uidHome',
		name: '游戏初始化',
		component: () => import('@/views/UidView.vue'),
	},
	{
		path: '/mHome',
		name: '游戏初始化',
		component: () => import('@/views/H5View.vue'),
	},
	{
		path: '/mUidHome',
		name: '游戏初始化',
		component: () => import('@/views/uidH5View.vue'),
	},
	{
		path: '/myTrade',
		name: '游戏初始化',
		component: () => import('@/views/MyTrade.vue'),
	},
	{
		path: '/mtrade',
		name: '游戏初始化',
		component: () => import('@/views/MyTradeH5.vue'),
	},
	{
		path: '/orderPay',
		name: '游戏初始化',
		component: () => import('@/views/PayH5.vue'),
	},
	{
		path: '/loading',
		name: '游戏初始化',
		component: () => import('@/views/Loading.vue'),
	},
	{
		path: '/final',
		name: '支付结果',
		component: () => import('@/views/Final.vue'),
		meta: {
			keepAlive: true, // 需要被缓存
		},
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

export default router;
